import React from "react"

const Loading: React.FC = () => {
    return (
        <div className="loading-screen">
            <div className="loading-screen__pulse">
                <img
                    src={`${process.env.PUBLIC_URL || ""}/web-app-manifest-512x512.png`}
                    alt="Bordik"
                    width={72}
                    height={72}
                    className="loading-screen__logo"
                />
            </div>
        </div>
    )
}

export default Loading
